import { useEffect } from "react";
import { useLocation } from "react-router-dom";
export var ScrollToTop = function () {
    var pathname = useLocation().pathname;
    useEffect(function () {
        // Scroll to top
        window.scrollTo(0, 0);
    }, [pathname]);
    return null;
};
